module.exports = {

    author: "@Uyadav207",
    siteTitle: "Utkarsh Yadav | portfolio",
    siteShortTitle: "Uy.", // Used as logo text in header, footer, and splash screen
    siteDescription: "Utkarsh Yadav",
    siteUrl: "https://utkarshdeveloper.netlify.app/",
    siteLanguage: "en_US",
    siteIcon: "src/content/favicon.png", // Relative to gatsby-config file

    splashScreen: false, // Set this to true if you want to use the splash screen
    //api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fdev.to%2Ffeed%2F%40uyadav207
    mediumRssFeed: "https://dev.to/uyadav207/random-color-generator-expo-app-5g4b",
    shownArticles: 0,
    
    socialMedia: [
        {
            name: "Linkedin",
            url: "https://www.linkedin.com/in/utkarsh-yadav-37242b17b/"
        },
        {
            name: "Dev.to",
            url: "https://dev.to/uyadav207"
        },
        {
            name: "Github",
            url: "https://github.com/Uyadav207"
        },
        {
            name: "Blogs",
            url: "https://utkarsh-blog.netlify.app/"
        },
    ],
  
    navLinks: {
        menu: [
            {
                name: "About Me 👋",
                url: "/#about",
            },
            {
                name: "Projects 🧰",
                url: "/#projects",
            },    
        ],
        button: {
            name: "Contact 🤝",
            url: "/#contact",
        }
    },

    footerLinks: [
        {
            name: "Testimonials",
            url: "/imprint"
        }
    ]
}